import { useEffect, useState } from 'react';
import { Stack, Group, Tabs, Button, Title } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';
import cn from 'clsx';
import { ContentCard } from 'src/components/ContentCard/ContentCard';
import { RequestPanel } from './RequestPanel';
import { ClaimPanel } from './ClaimPanel';

const TABS = [
  { value: 'request', searchParam: 'unstake' },
  { value: 'claim', searchParam: 'unstake-claim' },
];

const setTabFromSearchParams = (tabFromSearchParams?: string) => {
  const matchingTab = TABS.find(
    (tab) => tab.searchParam === tabFromSearchParams
  );
  return matchingTab ?? TABS[0];
};

export function UnstakePanel() {
  const [_searchParams, setSearchParams] = useSearchParams();
  const searchParams = Object.fromEntries(_searchParams.entries());
  const tabFromSearchParams = searchParams?.tab;
  const [activeTab, setActiveTab] = useState(
    setTabFromSearchParams(tabFromSearchParams).value
  );

  useEffect(() => {
    setActiveTab(setTabFromSearchParams(tabFromSearchParams).value);
  }, [tabFromSearchParams]);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    setSearchParams({
      tab:
        TABS.find((tab) => tab.value === value)?.searchParam ??
        TABS[0].searchParam,
    });
  };

  return (
    <ContentCard>
      <Stack gap={24}>
        <Group
          justify="space-between"
          gap={8}
          wrap="nowrap"
          grow
          p={4}
          className="bg-[#151519] rounded-[16px]"
        >
          {TABS.map((tab) => (
            <Button
              key={tab.value}
              h={38}
              fz={14}
              fw={600}
              tt="capitalize"
              variant="outline"
              className={cn(
                'text-[#2E2E38] hover:text-[#fff] active:text-[#fff] bg-transparent transition-colors border-transparent rounded-[12px]',
                tab.value === activeTab ? '!text-[#fff] !bg-[#202027]' : ''
              )}
              onClick={() => handleTabChange(tab.value)}
            >
              {tab.value}
            </Button>
          ))}
        </Group>

        <Tabs value={activeTab}>
          <Tabs.Panel value="request">
            <RequestPanel
              onRequestSuccess={() => {
                handleTabChange('claim');
              }}
            />
          </Tabs.Panel>
          <Tabs.Panel value="claim">
            <ClaimPanel />
          </Tabs.Panel>
        </Tabs>
      </Stack>
    </ContentCard>
  );
}
